import { useFieldArray, useFormContext } from "react-hook-form";
import { useAdditionalFieldsStore } from "../stores/additionalFieldsStore";
import { ReactNode, useEffect } from "react";
import { FieldType } from "../components/AdditionalMeetingFields";

export const AdditionalFieldsProvider = ({ children }: { children: ReactNode }) => {
  const { control } = useFormContext(); // Достаём control из useFormContext
  const { fields, append, remove, update } = useFieldArray({ name: "additionalFields", control });

  const baseFields = fields as FieldType[];

  // Обновляем Zustand только после рендера
  useEffect(() => {
    useAdditionalFieldsStore.setState({ fields: baseFields, append, remove, update });
  }, [JSON.stringify(baseFields), append, remove, update]);

  return children;
};
